import {arrowRightSvg as Icon__small__arrowRightSvg} from '../Icon__small/Icon__small--arrowRight.js';
import {arrowRightSvg as Icon__xsmall__arrowRightSvg} from '../Icon__xsmall/Icon__xsmall--arrowRight.js';

export var arrowRight = {
  name: 'arrowRight',
  category: 'icon',
  colorable: true,
  svg: Icon__small__arrowRightSvg,
  alt: {
    Icon__small: Icon__small__arrowRightSvg,
    Icon__xsmall: Icon__xsmall__arrowRightSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall'],
};
